import styled from 'styled-components';
export const OrderedList = styled.ol `
  font-size: ${({ theme }) => theme.fontSizes.s};
  padding-inline-start: ${({ theme }) => theme.space.x6};
  line-height: 1.5;
  list-style-type: decimal;

  & > ol,
  & > li > ol {
    list-style-type: lower-latin;

    & > ol,
    & > li > ol {
      list-style-type: lower-roman;
    }
  }
`;
